import React, {useEffect} from 'react'
import { getAuth, signOut } from "firebase/auth";
import {useHistory} from "react-router-dom";

function Logout() {
    let history = useHistory();

    useEffect(() => {
        const auth = getAuth();
        signOut(auth).then(() => {
            history.push("/")
        }).catch((error) => {
            // An error happened.
        });
    }, [])

    return (
        <div></div>
    )
}

export default Logout;
